module.exports = __webpack_public_path__ + "static/1241736799.d55dd2f1.jpg";